import { Component, OnInit, AfterContentInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, HostListener, AfterViewChecked, OnDestroy, ChangeDetectorRef, ElementRef } from '@angular/core'
import { CtrlBaseComponent } from '../ctrl-base.component';
import { ADN_PLUS, Action } from '../../models';
import { StepperItemTypes, StepperVersion, stepperItemImageType } from '../../enums/stepper';
import { PfComponents } from '../../enums/pfComponents';
import { breakpoints } from '../../environments/environment.breakpoints';
import { CtButtonComponent } from '../ct-button/ct-button.component';
import { CurrencyPipe } from '@angular/common';
import { ServiceLocator } from '../../ServiceLocator';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
@Component({
  selector: '[ct-stepper-item]',
  templateUrl: './ct-stepper-item.component.html',
  styleUrls: ['./ct-stepper-item.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'
  }
})

export class CtStepperItemComponent extends CtrlBaseComponent implements OnInit, OnDestroy{

  @ViewChild('embeddedView', { read: ViewContainerRef }) target;
  @ViewChild('nextButton', { read: ViewContainerRef }) nextButton;
  @ViewChild('prevButton', { read: ViewContainerRef }) prevButton;
  @ViewChild('prevButtonXS', { read: ViewContainerRef }) prevButtonXS;
  @ViewChild('nextButtonXS', { read: ViewContainerRef }) nextButtonXS;
  @ViewChild('validationBtnCompressed') public validationBtnCompressed : ElementRef<HTMLButtonElement>;

  private title: any;
  private description: any;
  private iconClass: any;
  private currentItem: any;
  private viewCode: any;
  private readOnly: boolean = false;
  private disabledMessage: string = '';
  private disabledDescription: string = '';
  private isBackButtonDisabled: boolean = false;

  private getValueFrom: string;
  private adnEntityField: string;
  private adnShowValue: string;
  private contextAdn: ADN_PLUS;
  private contextComponentId: string;

  private setValueTo: string;
  private autoSearch: boolean = true;
  private sectionsToHide: string;
  private attempts = 0;
  private loaded = false;
  private loadOnce;

  private active: boolean = false;
  private state: string = 'unloaded';
  private icon: string;

  //version interfaz
  public stepperVersion: StepperVersion;
  private stepperItemType : StepperItemTypes;
  private nextButtonText : string = 'Siguiente';
  private prevButtonText : string = 'Atrás';
  private validationButtonText : string = 'Validar';
  private stepperItemImageType : stepperItemImageType = stepperItemImageType.none;

  //stepper full
  private isStepperFullFixed : boolean = true;
  private isStepperFullFullWidth : boolean = false;

  //util
  public isMedium : boolean = false;
  public isSmall : boolean = false;
  public isExtraSmall : boolean = false;

  public stepperItemTypeEnum = StepperItemTypes;

  //components
  public nextButtonComponent : CtButtonComponent;
  public backButtonComponent : CtButtonComponent;

  //footer
  private footerDescription : string;
  private footerDescriptionValue : string;
  private isFooterDescriptionCurrency : boolean;
  private footerDescriptionCurrency : string;

  //util
  private resizeSubscription : any;

  //constants
  public stepperItemImagetypeSvg : Map<stepperItemImageType, string> = new Map<stepperItemImageType, string>([
    [stepperItemImageType.success, 'assets/icons/check.svg']
  ]);

  public iconWidth : number = 65;
  public iconHeight : number = 75;
  
  constructor(private cdr : ChangeDetectorRef) {
    super();
  }

  ngOnDestroy(): void {
    this.resizeSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.checkScreenSize();
    if (!this.getMetaData()) {
      this.setMetaData({
        id: "stiPaso1",
        ctType: "CtStepperItem",
        controlProperties: {
          hidden: false,
          parentId: ""
        },
        controlActions: {},
        encodedJson: false
      });
    }

    this.setProperties(this);
    this.subscribeToOnResizeChanges();
  }

  private subscribeToOnResizeChanges() {
    const resizeEvents = fromEvent(window, 'resize');
    this.resizeSubscription = resizeEvents
      .pipe(
        debounceTime(250)
      ).subscribe(() => {
        window.requestAnimationFrame(() => {
          this.checkScreenSize();
        });
      })
  }

  ngAfterViewInit() {
    if(this.stepperVersion === StepperVersion.Full) this.setStepperFullBarProperties();
    if (this.getViewCode()) {
      this.loadEmbeddedView();
      this.hideSectionsOnView();
    } else {
      this.paintChildren(this.getMetaData(), this.target);
    }
    this.checkScreenSize();
  }

  /**
   * This function checks the screen size and sets boolean variables based on the breakpoints defined.
  */
  private checkScreenSize() : void {
    const screenWidth = window.innerWidth;
    this.isMedium = screenWidth >= breakpoints.L;
    this.isSmall = screenWidth < breakpoints.L && screenWidth > breakpoints.M;
    this.isExtraSmall = screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
    this.cdr.detectChanges();
    this.manageStepperFullButtonSizes();
  }

  private manageStepperFullButtonSizes() {
    if(this.stepperVersion !== StepperVersion.Full) return;
    if(!this.nextButtonComponent && !this.backButtonComponent) return;

    let nextButtonMetadata : any = this.nextButtonComponent.getMetaData();
    let backButtonMetadata : any = this.backButtonComponent.getMetaData();

    if(this.isMedium || this.isSmall) {
      nextButtonMetadata.controlProperties.width = 250;
      backButtonMetadata.controlProperties.width = 250;
      nextButtonMetadata.controlProperties.btnBlock = false;
      backButtonMetadata.controlProperties.btnBlock = false;
    } else {
      nextButtonMetadata.controlProperties.width = null;
      backButtonMetadata.controlProperties.width = null;
      nextButtonMetadata.controlProperties.btnBlock = true;
      backButtonMetadata.controlProperties.btnBlock = true;
    }
    nextButtonMetadata.controlProperties.hidden = this.nextButtonComponent.getHidden();
    backButtonMetadata.controlProperties.hidden = this.backButtonComponent.getHidden();
    backButtonMetadata.controlProperties.disabled = this.nextButtonComponent.getDisabled();
    nextButtonMetadata.controlProperties.disabled = this.backButtonComponent.getDisabled();
    this.paintStepperFullButtons(nextButtonMetadata,backButtonMetadata);
  }
  
  /**
   * creates back and next buttons for the Full stepper options.
   */
  private setStepperFullBarProperties(): void {
    const metadata = this.createMetadata();
    const backButton = this.createBackButton(metadata);
    this.paintStepperFullButtons(metadata, backButton);
  }

  private paintStepperFullButtons(nextButtonMetadata : any, backButtonMetadata : any): void {
    const nextButtonContainer = this.isExtraSmall ? this.nextButtonXS : this.nextButton;
    const backButtonContainer = this.isExtraSmall ? this.prevButtonXS : this.prevButton;
    if(!nextButtonContainer || !backButtonContainer) return;
    this.nextButtonComponent = this.paintChildren({models : [nextButtonMetadata]}, nextButtonContainer)[0] as CtButtonComponent;
    this.backButtonComponent = this.paintChildren({models: [backButtonMetadata]}, backButtonContainer)[0] as CtButtonComponent;
  }


  /**
   * Next button of Full stepper options.
   */
  private createMetadata(): any {
    let action : Action = this.getEvent('onNextButton');
    if(action) action.eventName = 'onClick';
    return {
      ctType: PfComponents.CtButton,
      controlProperties: {  
        hidden : false,
        disabled: false,
        listenedComponentId: "",
        listenedProperty: "",
        modelId : '',
        width: 200,
        buttonText: this.nextButtonText,
        buttonColor: 'primary',
        icon: "",
        id: `${this.getViewId()}_${PfComponents.CtButton}_default_${0}`,
      },
      controlActions: [action || []],
      models: []
    };
  }

  /**
   * Back button of Full stepper options.
   */
  private createBackButton(metadata: any): any {
    let action : Action = this.getEvent('onPrevButton');
    if(action) action.eventName = 'onClick';
    const backButton = JSON.parse(JSON.stringify(metadata));
    backButton.controlProperties.buttonText = this.prevButtonText;
    backButton.controlProperties.id = `${this.getViewId()}_${PfComponents.CtButton}_default_${1}`;
    backButton.controlActions = [action|| []];
    backButton.controlProperties.buttonColor = 'default';
    backButton.controlProperties.hidden = this.getIsBackButtonDisabled();
  
    return backButton;
  }
  
  setDisabledProperties() {
    this.setReadOnly(this.getReadOnly());
  }

  hideSectionsOnView() {
    if (!this.getSectionsToHide() || this.getSectionsToHide() == "") return;
    let comp : any;
    let a : any = this.getSectionsToHide().split(',');
    this.attempts += 0.5;
    if (this.attempts > 10) return;
    for (let i = 0; i < a.length; i++) {
      let s : any= a[i];
      comp = this.utilService.getComponentRef(s);
      if (!comp) {
        console.log(`Can't find ${s}, on ${this.getViewCode()} retying to hide on ${this.attempts}s`);
        setTimeout(() => {
          this.hideSectionsOnView();
        }, (this.attempts * 1000));
        continue;
      } else {
        comp.setHidden(true);
      }
    }
  }

  loadEmbeddedView() {
    let componentRef : any;
    if (this.getViewCode() && this.getViewCode().toUpperCase() != 'MYVIEW') {
      try {
        let view = this.paintService.vViewComponents[this.getViewCode()];
        let componentFactory = this.compiler.resolveComponentFactory(view);
        componentRef = this.target.createComponent(componentFactory);
      } catch (e) {
      }
    }
  }

  bindContext() {
    if (!this.getContextComponentId() || this.getContextComponentId() == "") return
    let adn = this.utilService.getAdnFromAnyComponent(this.getContextComponentId());
    this.setContextAdn(adn);
  }

  onNextButton(){
    this.event2('onNextButton')
  }

  onPrevButton(){
    this.event2('onPrevButton')
  }

  public getStepperImage(): string {
    if(this.stepperItemImageType == stepperItemImageType.none) return;
    return this.stepperItemImagetypeSvg.get(this.getStepperItemImageType());
  }

  public get stepperType(): typeof StepperVersion {
    return StepperVersion; 
  }

  public get stepperImageType(): typeof stepperItemImageType {
    return stepperItemImageType;
  }

  getTitle() { return this.title }
  getDescription() { return this.description }
  getIconClass() { return this.iconClass }
  getCurrentItem() { return this.currentItem }
  getViewCode() { return this.viewCode }
  getReadOnly(): boolean { return this.readOnly }
  getDisabledMessage(): string { return this.disabledMessage }
  getDisabledDescription(): string { return this.disabledDescription }
  getGetValueFrom(): string { return this.getValueFrom }
  getAdnEntityField(): string { return this.adnEntityField }
  getAdnShowValue(): string { return this.adnShowValue }
  getSetValueTo(): string { return this.setValueTo }
  getAutoSearch(): boolean { return this.autoSearch }
  getSectionsToHide(): string { return this.sectionsToHide }
  getContextAdn(): ADN_PLUS { return this.contextAdn }
  getContextComponentId(): string { return this.contextComponentId }
  getLoadOnce(): boolean { return this.loadOnce }
  getActive(): boolean { return this.active }
  getState(): string { return this.state }
  getIcon(): string { return this.icon }
  getStepperItemType(): StepperItemTypes { return this.stepperItemType }
  getIsDefaultStepperItem(): boolean { return this.stepperItemType === StepperItemTypes.default }
  getIsValidationStepperItem(): boolean { return this.stepperItemType === StepperItemTypes.validation }
  getNextButtonText(): string { return this.nextButtonText };
  getPrevButtonText(): string { return this.prevButtonText };
  getValidationButtonText(): string { return this.validationButtonText };
  getStepperVersion() { return this.stepperVersion }
  getStepperItemImageType() { return this.stepperItemImageType }
  getIsStepperFullFixed() { return this.isStepperFullFixed }
  getIsBackButtonDisabled() { return this.isBackButtonDisabled }
  getIsStepperFullFullWidth() { return this.isStepperFullFullWidth }
  getFooterDescription() { return this.footerDescription }
  getFooterDescriptionValue() { return this.footerDescriptionValue }
  getIsFooterDescriptionCurrency() { return this.isFooterDescriptionCurrency }
  getFooterDescriptionCurrency() { return this.footerDescriptionCurrency }

  setTitle(pValue: any) { this.title = pValue }
  setDescription(pValue: any) { this.description = pValue }
  setIconClass(pValue: any) { this.iconClass = pValue }
  setCurrentItem(pValue: any) { this.currentItem = pValue }
  setViewCode(pValue: any) { this.viewCode = pValue }
  setReadOnly(readOnly: boolean): void {
    this.getMetaData().controlProperties['readOnly'] = readOnly;
    this.readOnly = readOnly;
  }
  setDisabledMessage(pMessage: string): void { this.disabledMessage = pMessage }
  setDisabledDescription(pDescription: string): void { this.disabledDescription = pDescription }
  setGetValueFrom(pComponentId: string): void { this.getValueFrom = pComponentId }
  setAdnEntityField(pEntityFieldName: string): void { this.adnEntityField = pEntityFieldName }
  setAdnShowValue(pAdnShowValue: string): void {
    this.getMetaData().controlProperties['adnShowValue'] = pAdnShowValue;
    this.adnShowValue = pAdnShowValue
  }
  setSetValueTo(pComponentId: string): void { this.setValueTo = pComponentId }
  setAutoSearch(pAutoSearch: boolean): void { this.autoSearch = pAutoSearch }
  setSectionsToHide(pSectionsToHide: string): void { this.sectionsToHide = pSectionsToHide }
  setContextComponentId(pContextComponentId: string): void { this.contextComponentId = pContextComponentId }
  setContextAdn(pcontextAdn: ADN_PLUS): void {
    this.contextAdn = new ADN_PLUS(pcontextAdn);
    this.setAdnShowValue(this.getContextAdn().getStringAttribute(this.getAdnEntityField()));
  }
  setLoadOnce(loadOnce: boolean): void { this.loadOnce = loadOnce }
  setLoaded(loaded): void { this.loaded = loaded }
  setState(state: string): void { this.state = state }
  setActive(active: boolean): void { this.active = active }
  setIcon(icon: string): void { this.icon = icon }
  setNextButtonText(nextButtonText : string): void { this.nextButtonText = nextButtonText };
  setPrevButtonText(prevButtonText : string): void { this.prevButtonText = prevButtonText };
  setValidationButtonText(validationButtonText : string): void { this.validationButtonText = validationButtonText };
  setStepperItemType(stepperItemType : StepperItemTypes): void  {this.stepperItemType = stepperItemType};
  setStepperVersion(stepperVersion: StepperVersion) { this.stepperVersion = stepperVersion }
  setStepperItemImageType(pValue: stepperItemImageType) { this.stepperItemImageType = pValue }
  setIsStepperFullFixed(pValue: boolean) { this.isStepperFullFixed = pValue }
  setIsBackButtonDisabled(pValue: boolean) { this.isBackButtonDisabled = pValue }
  setIsStepperFullFullWidth(pValue: boolean) { this.isStepperFullFullWidth = pValue }
  setFooterDescription(pValue: string) { this.footerDescription = pValue }
  setFooterDescriptionValue(pValue: string) { this.footerDescriptionValue = pValue }
  setIsFooterDescriptionCurrency(pValue: boolean) { this.isFooterDescriptionCurrency = pValue }
  setFooterDescriptionCurrency(pValue: string) { this.footerDescriptionCurrency = pValue }
}